import VideoSprite from './VideoSprite'

export default class VideoContainer extends PIXI.Container{
  constructor(data) {
    super()
    this._data = data

    const video = new VideoSprite(this._data)
    video.anchor.set(0.5, 0.5)

    this.addChild(video)
  }
}
